<template>
  <div>
    <common-dialog
      ref="dialog"
      width="350px"
      center
      title="导入 功课表信息"
      id-key="ClassId"
      :save-func="()=>{}"
      :confirm-on-close-change="false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="学期名称">
          <span>{{Term.Name}}</span>
        </el-form-item>
        <el-form-item label="选择星期">
          <week-picker
            ref="weekPicker"
            :s-date="Term.Start"
            w="100%"
            :e-date="Term.End"
            @change="onChange"
          />
        </el-form-item>
        <div style="margin-left: 17px;margin-bottom: 30px;">
          <div style="margin-top: 15px;display: flex;justify-content: space-between;">
            <import-file
              w="120px"
              :upload-url="api.import + '?TermId=' + Term.Id+'&weekStartDate='+data.Start+'&weekEndDate='+data.End"
              text="导入功课表信息"
              :before-upload="onBeforeUpload"
              @on-uploaded="uploaded"
            />
            <el-button size="mini" class="download" plain @click="download">下载信息模板</el-button>
          </div>
          <div style="margin-top: 15px;" v-if="detailUrl">
            <el-button size="mini" style="width: 120px;" type="danger" plain @click="detail">下载错误明细</el-button>
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";
import weekPicker from "@/components/common/weekPicker";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
    weekPicker,
  },
  data() {
    return {
      api: require("@/api/ed/timetable").default,
      attach: require("@/api/common/attach").default,
      termApi: require("@/api/ed/term").default,
      detailUrl: "",
      Term: {
        Id: null,
        Name: "",
        Start: "",
        End: "",
      },
      data: {
        Start: "",
        End: "",
      },
    };
  },
  computed: {},
  methods: {
    setTerm(data) {
      this.Term.Id = data.TermId;
      this.Term.Name = data.TermName;
      this.termApi.info(this.Term.Id).then((res) => {
        if (res.Code == 0) {
          this.Term.Start = this.$commonJs.toDateString(res.Data.StartTime);
          this.Term.End = this.$commonJs.toDateString(res.Data.EndTime);
          this.$refs.weekPicker.init();
        }
      });
    },
    onChange(data) {
      this.data.Start = data.start;
      this.data.End = data.end;
    },
    onBeforeUpload() {
      if (!this.data.Start) {
        this.$message.warning("请选择要导入的星期");
        return false;
      }
      return true;
    },
    download() {
      var url = "/Template/功课表导入模板.xlsx";
      this.attach.downloadByUrl(url, "功课表导入模板.xlsx");
    },
    detail() {
      this.attach.downloadByUrl(this.detailUrl, "错误明细.xlsx");
    },
    uploaded(res) {
      console.log("uploaded", res);
      if (res.Code != 0) {
        if (res.Code == 2) {
          this.detailUrl = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      } else {
        this.$emit("upload-success");
        this.detailUrl = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.download {
  width: 120px;
  margin-left: 10px;
}
</style>